import { Box } from "@mui/joy";
import { CheckIcon, CloseIcon, CancelIcon } from "../../../styles/StyledMUI";
import IconButtonCTA from "../../common/IconButtonCTA";
import type { LeaveRequest } from "../../../api/leave/Leave.typed";
import { LeaveStatus } from "../../../api/leave/Leave.typed";
import { excursionBookingCompactCtaSx } from "../../../styles/globalStyles";

export type LeaveValidationRequestActionsProps = {
  request: LeaveRequest;
  canValidate: boolean;
  onApprove: (requestId: number) => void;
  onReject: (requestId: number) => void;
  onCancel: (requestId: number) => void;
  onApproveCancellation: (requestId: number) => void;
  onRejectCancellation: (requestId: number) => void;
  compact?: boolean;
};

export default function LeaveValidationRequestActions({
  request,
  canValidate,
  onApprove,
  onReject,
  onCancel,
  onApproveCancellation,
  onRejectCancellation,
  compact = false,
}: LeaveValidationRequestActionsProps) {
  if (!canValidate) {
    return null;
  }

  const btnSx = compact ? excursionBookingCompactCtaSx : undefined;

  return (
    <Box sx={{ display: "flex", gap: compact ? 0.5 : 1, flexWrap: "nowrap", flexShrink: 0 }}>
      {request.status === LeaveStatus.PENDING && (
        <>
          <IconButtonCTA
            aria-label="Approuver la demande"
            ctaVariant="success"
            size="sm"
            sx={btnSx}
            onClick={() => onApprove(request.id)}
          >
            <CheckIcon sx={compact ? { fontSize: 14 } : undefined} />
          </IconButtonCTA>
          <IconButtonCTA
            aria-label="Refuser la demande"
            ctaVariant="danger"
            size="sm"
            sx={btnSx}
            onClick={() => onReject(request.id)}
          >
            <CloseIcon sx={compact ? { fontSize: 14 } : undefined} />
          </IconButtonCTA>
        </>
      )}
      {request.status === LeaveStatus.APPROVED && (
        <IconButtonCTA
          aria-label="Annuler la demande approuvée"
          ctaVariant="danger"
          size="sm"
          sx={btnSx}
          onClick={() => onCancel(request.id)}
        >
          <CancelIcon sx={compact ? { fontSize: 14 } : undefined} />
        </IconButtonCTA>
      )}
      {request.status === LeaveStatus.CANCELLATION_REQUESTED && (
        <>
          <IconButtonCTA
            aria-label="Approuver l'annulation"
            ctaVariant="success"
            size="sm"
            sx={btnSx}
            onClick={() => onApproveCancellation(request.id)}
          >
            <CheckIcon sx={compact ? { fontSize: 14 } : undefined} />
          </IconButtonCTA>
          <IconButtonCTA
            aria-label="Refuser l'annulation"
            ctaVariant="danger"
            size="sm"
            sx={btnSx}
            onClick={() => onRejectCancellation(request.id)}
          >
            <CloseIcon sx={compact ? { fontSize: 14 } : undefined} />
          </IconButtonCTA>
        </>
      )}
    </Box>
  );
}
